// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"31d6cfe0","226":"a83b80c0","320":"31d6cfe0"}[chunkId] + ".chunk.css";
};